// The chat's window events: any part of the host app opens a chat window with them.

/** Opens the chat with a draft ("Ask the agent" on an app): `window.dispatchEvent(openChatEvent(text))`. */
export const OPEN_CHAT_EVENT = 'chat:open';
export const openChatEvent = (draft: string) => new CustomEvent(OPEN_CHAT_EVENT, { detail: { draft } });

/** Opens a chat window from anywhere (the old platform's open-harness event): { harness?, initialPrompt?, selectedAgent? }. */
export const OPEN_HARNESS_EVENT = 'chat:open-harness';
